import { store } from "configureStore";
import UserStorage from "./userStorage";

const AuthService = {
  // Get JWT from the store or from the user storage
  getJwt() {
    return UserStorage.getStorageValue("jwt");
  },

  // Store JWT in user storage
  storeJwt(jwt) {
    UserStorage.setStorageValue("jwt", jwt);
  },

  // Remove JWT from user storage
  discardJwt() {
    UserStorage.clearStorageValue("jwt");
  },

  // Get the global data object from the store or from the user storage
  getUserData() {
    const state = store.getState();

    return state?.global?.data;
  },

  // Get Policy Group from the global data
  getPolicyGroup() {
    return this.getUserData()?.policy_group;
  },

  // Get Enterprise from the global data
  getEnterprise() {
    return this.getUserData()?.enterprise;
  },

  // *************** Helpers ***************

  // Returns true if the user is authenticated and the data is in the store
  isUserInStore() {
    const state = store.getState();

    return !!state?.global?.token;
  },

  // Returns true if the passed in routeData object contains a `permission` property that contains
  // a string which represents the field name of the permission in the user's policy group
  //
  // Note: routeData should be passed directly from the route object from `util/routePaths.ts`
  hasPermission(routeData) {
    // If routeData is empty or doesn't contain a permission property then there's no
    // permission for the provided page so the user is authorized
    if (
      !routeData ||
      Object.prototype.hasOwnProperty.call(routeData, "permission") === false
    ) {
      return true;
    }

    return AuthService.getPolicyGroup()[routeData.permission] === true;
  },
};

export default AuthService;
